import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { ContextProvider } from './store/context'

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_MSW) {
  const { worker } = require('./__mocks__/browser')
  worker.start()
}

const rootEl = document.getElementById('root')
if (rootEl) {
  rootEl.style.cssText = `
    height: 100%;
    display: flex;
    flex-direction: column;
  `
}

const root = createRoot(rootEl!)

root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
)
